import modalStyle from "../../../assets/scss/common/modal/modal.module.scss";
import styles from "../../../assets/scss/common/modal/loginModal.module.scss";
import {Modal} from "./Modal";
import {useCallback, useEffect, useState} from "react";
import {useAppSelector, useLoader, useModal} from "../../../hooks/hooks";
import {loginStatus} from "../../../store/login/loginSlice";
import {ModalType} from "../../../types/common";
import {EmailStep} from "./login/EmailStep";
import {CodeStep} from "./login/CodeStep";
import {AuthWayChoiceStep} from "./login/AuthWayChoiceStep";
import {useTranslation} from "react-i18next";

export enum LoginStep {
  EMAIL = "EMAIL",
  AUTH_WAY = "AUTH_WAY",
  EMAIL_CODE = "EMAIL_CODE",
  PHONE_NUMBER_CODE = "PHONE_NUMBER_CODE",
}

export function LoginModal() {
  const { t } = useTranslation("signupModal");
  const status = useAppSelector(loginStatus);
  const { showModal, closeModal, openAlertModal } = useModal();
  const { setLoaderStatus } = useLoader();

  const [loginStep, setLoginStep] = useState<LoginStep>(LoginStep.EMAIL);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [incorrectCodeCount, setIncorrectCodeCount] = useState(0);
  const [isBackAfterSendingCode, setIsBackAfterSendingCode] = useState(false);
  const [title, setTitle] = useState(t("signupAndLogin.title"))

  const onClickCloseBtn = () => closeModal();

  const changeLoginStep = useCallback((step: LoginStep) => setLoginStep(step), []);

  useEffect(() =>{
    setTitle(t("signupAndLogin.title"))
  },[t])

  useEffect(() => {
    setLoaderStatus([status]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  useEffect(() => {
    if (loginStep === LoginStep.EMAIL) {
      setEmail("");
    }
  }, [loginStep]);

  // const { isDesktop, isTablet } = useUserAgent();

  const [hasCheckedInApp, setHasCheckedInApp] = useState(false);
  const [blockByInApp, setBlockByInApp] = useState(false);

  useEffect(() => {
    if (hasCheckedInApp) return;

    const isInAppBrowser = () => {
      const ua = window.navigator.userAgent.toLowerCase();
      return /kakaotalk|instagram|fbav|line/.test(ua);
    };

    if (isInAppBrowser()) {
      setBlockByInApp(true);
      openAlertModal({
        title: "안내",
        desc: "인앱 브라우저(카카오톡, 인스타그램)에서는 회원가입이 정상적으로 동작하지 않을 수 있습니다.\n기본 인터넷 어플, Chrome, Safari 등 브라우저에서 다시 시도해주세요.",
        callback: () => {
          closeModal();
        },
      });
    }

    setHasCheckedInApp(true);
    console.log('isInAppBrowser(): ',isInAppBrowser())
    // eslint-disable-next-line
  }, []);

  return (
      <Modal
          showModal={showModal.valueOf() === ModalType.LOGIN.valueOf()}
          title={title}
          closeModalFunction={onClickCloseBtn}
          modalBgStyle={modalStyle.mainColorBg}
          modalCloseButtonStyle={modalStyle.mainColorBg}
          modalOtherStyle={`${modalStyle.loginModal} ${styles.wrapper}`}
      >
        <div className={styles.content}>
          {!blockByInApp && loginStep === LoginStep.EMAIL && (
              <EmailStep
                  changeLoginStep={changeLoginStep}
                  incorrectCodeCount={incorrectCodeCount}
                  setIncorrectCodeCount={setIncorrectCodeCount}
                  email={email}
                  setEmail={setEmail}
                  isBackAfterSendingCode={isBackAfterSendingCode}
                  setIsBackAfterSendingCode={setIsBackAfterSendingCode}
              />
          )}
          {loginStep === LoginStep.AUTH_WAY && (
              <AuthWayChoiceStep
                  email={email}
                  changeLoginStep={changeLoginStep}
                  setPhoneNumber={setPhoneNumber}
                  phoneNumber={phoneNumber}
                  setTitle={setTitle}
              />
          )}
          {(loginStep === LoginStep.EMAIL_CODE || loginStep === LoginStep.PHONE_NUMBER_CODE) && (
              <CodeStep
                  changeLoginStep={changeLoginStep}
                  setIncorrectCodeCount={setIncorrectCodeCount}
                  email={email}
                  step={loginStep}
                  phoneNumber={phoneNumber}
                  setIsBackAfterSendingCode={setIsBackAfterSendingCode}
              />
          )}
        </div>
      </Modal>
  );
}
